<section class="background-color-nearwhite">
    <div class="container">
        <h1 [innerHTML]="'booking.bookingConfirmation.title' | translate"></h1>
        <p class="intro" [innerHTML]="'booking.bookingConfirmation.intro' | translate"></p>
    </div>
    <div *ngIf="failingCourseList" class="container hint-box">
        <h3><span [innerHTML]="'booking.bookingConfirmation.hintLabel' | translate"></span> <span [innerHTML]="'booking.bookingConfirmation.hintTitle' | translate"></span></h3>
        <ul class="failing-course-items-list">
            <li *ngFor="let failingCourse of failingCourseList">{{failingCourse}}</li>
        </ul>
        <p [innerHTML]="'booking.bookingConfirmation.pleaseContactText' | translate"></p>
    </div>
</section>

<section class="background-color-white" *ngIf="events$ | async as events">
    <div class="container" *ngIf="events.length > 0">
        <da-hotels-list [events]="events"></da-hotels-list>
    </div>
</section>
